@if (inProgress) {
  <div>
    <div class="progress-container" [ngClass]="size">
      <div class="inline-loader"></div>
    </div>
    @if (label) {
      <span class="loader-text">{{ label }}</span>
    }
  </div>
}
